import { utcToZonedTime, format as formatTz } from 'date-fns-tz';

/** Parses a .NET datetime string, truncating fractional seconds to 3 digits and ensuring UTC interpretation. */
const parseDate = (s: string) => {
  let normalized = s.replace(/(\.\d{3})\d+/, '$1');
  // .NET often omits the Z suffix — treat naive timestamps as UTC
  if (!/[Zz]|[+-]\d{2}:\d{2}$|[+-]\d{4}$/.test(normalized)) normalized += 'Z';
  return new Date(normalized);
};

/**
 * Format a date string in the given timezone.
 * @param dateStr ISO date string or parseable date string from the API
 * @param timezone IANA timezone string (e.g., 'America/New_York', 'UTC')
 * @param fmt date-fns format string (default: 'yyyy-MM-dd HH:mm:ss')
 */
export const formatDateWithTz = (
  dateStr: string,
  timezone: string,
  fmt: string = 'yyyy-MM-dd HH:mm:ss'
): string => {
  if (!dateStr) return '';
  const date = parseDate(dateStr);
  const zonedDate = utcToZonedTime(date, timezone);
  return formatTz(zonedDate, fmt, { timeZone: timezone });
};

/**
 * Compute run time as HH:MM:SS from two date strings.
 */
export const computeRunTime = (started: string, ended: string): string => {
  if (!started || !ended) return '';
  const diffMs = parseDate(ended).getTime() - parseDate(started).getTime();
  if (diffMs < 0) return '';
  const totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};
